import { brandAssets } from './brandAssets.js';

interface Props {
  displayWidth: number;
  className?: string;
}

export function DocumentScanIllustration({ displayWidth, className }: Props) {
  const intrinsic = brandAssets.documentScan.intrinsic;

  return (
    <img
      className={className}
      src={brandAssets.documentScan.png640}
      alt="ScrubLedger clinical document scanning illustration"
      width={intrinsic}
      height={intrinsic}
      loading="lazy"
      decoding="async"
      style={{ width: displayWidth, height: 'auto', maxWidth: '100%' }}
    />
  );
}
